






import { Component, Vue } from "vue-property-decorator";
import AuditKepatuhanPpiList from "@/components/ppi/audit-kepatuhan-ppi/AuditKepatuhanPpiList.vue";

@Component({
  components: { AuditKepatuhanPpiList }
})
export default class AuditKepatuhanPpiPage extends Vue {}
